import { FC } from 'react';

interface Props {
  position?: 'local' | 'global';
}

const Spinner: FC<Props> = ({ position = 'local' }) => (
  <div className={`spinner__wrapper spinner__wrapper--${position}`}>
    <div className='spinner' />
  </div>
);

export default Spinner;
